import styled from 'styled-components';

export default styled.form`
  position: relative;
  margin-top: 15px;
  width: 280px;
  margin: 0 auto;
`;



// WEBPACK FOOTER //
// ./src/components/CustomSelect/styled/SelectWrapper.js